var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.982 0C8.046 0 0 8.064 0 18C0 27.936 8.046 36 17.982 36C27.936 36 36 27.936 36 18C36 8.064 27.936 0 17.982 0ZM18 32.4C10.044 32.4 3.6 25.956 3.6 18C3.6 10.044 10.044 3.6 18 3.6C25.956 3.6 32.4 10.044 32.4 18C32.4 25.956 25.956 32.4 18 32.4ZM12.8185 16.4832C12.1156 17.1861 10.9759 17.1861 10.273 16.4832C9.57002 15.7802 9.57002 14.6405 10.273 13.9376L16.6369 7.57362C17.3399 6.87067 18.4796 6.87068 19.1825 7.57362L19.1962 7.58748L25.5466 13.9379C26.2495 14.6408 26.2495 15.7805 25.5466 16.4834C24.8437 17.1864 23.704 17.1864 23.001 16.4834L19.8 13.2824V27.0003C19.8 27.9944 18.9941 28.8003 18 28.8003C17.0059 28.8003 16.2 27.9944 16.2 27.0003V13.1017L12.8185 16.4832Z",
    fill: "#A614B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.ce25b4e86ca07ae66827af84d3cac8c0.svg";
export { ForwardRef as ReactComponent };